import React from "react";
import "./Request.css";
import Projects from "../../Works/AllWork.json";

const Request = props => {
  return (
    <div className="container-background-color pt-5 pb-5">
      {Projects.map((project, index) => {
        return project.projectId === +props.projectId ? (
          <div className="row">
            <div className="text-center col-xs-12 col-sm-10 offset-sm-1 col-md-12 offset-md-0 col-lg-10 offset-lg-1 col-xl-10 offset-xl-1 px-5">
              <div className="mx-auto">
                <h1 className="pb-4 project-title-size">
                  Our Client's Request
                </h1>
                <div class="speech-bubble" data-AOS="fade-right">
                  <div class="arrow bottom arrow-right" />
                  {project.clientRequest}
                </div>
              </div>
            </div>
          </div>
        ) : null;
      })}
    </div>
  );
};

export default Request;



// WEBPACK FOOTER //
// ./src/components/SingleProject/Request/Request.js